import { render } from "./Back.vue?vue&type=template&id=dcbf64ac&scoped=true"
const script = {}

import "./Back.vue?vue&type=style&index=0&id=dcbf64ac&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcbf64ac"]])

export default __exports__